import React from 'react'

const Footer = () => {
  return (
    <footer style={{justifyContent:'center', alignItems:'center'}}>
      <p>Copyright &copy;2024 Allen Institute, All rights reserved </p>
    </footer>
  )
}

export default Footer